import { createSlice } from '@reduxjs/toolkit';

const initialState: string[] = null as any;

const blockDeletedCacheSlice = createSlice({
	name: 'blockDeletedCache',
	initialState,
	reducers: {
		setBlockDeleted: (state, action) => {
			// eslint-disable-next-line no-param-reassign
			state = [...state, action.payload];
		},
		resetBlockDeteted: () => initialState
	}
});

export const { setBlockDeleted, resetBlockDeteted } = blockDeletedCacheSlice.actions;
export default blockDeletedCacheSlice.reducer;
